import React, { useState } from "react";
import "../../CSS/Signup.css";
import axios from "axios";
import CryptoJS from "crypto-js";

const SigninForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false); // Loader state

  const signin = async () => {
    if (email.length <= 3 || password.length === 0) {
      setMsg("Please enter all details");
      return;
    }

    setLoading(true);
    setMsg(<i className="fa fa-circle-o-notch fa-spin mt-2" style={{ fontSize: "30px", color: "#000" }}></i>);

    try {
      const encrypt1 = CryptoJS.AES.encrypt(email, "key").toString();
      const encrypt2 = CryptoJS.AES.encrypt(password, "key").toString();

      const response = await axios.post("https://api.mahirefrigeration.com/api/signin", {
        encrypt1,
        encrypt2,
      });

      if (response.data.success) {
        sessionStorage.setItem("token", response.data.token);
        sessionStorage.setItem("email", response.data.email);
        window.location.href = "/ticket"; // Redirect on success
      } else {
        setMsg(response.data.message || "Login failed");
      }
    } catch (error) {
      setMsg(error.response?.data?.message || "User doesn't exist");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="parent" style={{ position: "relative", height: "100vh" }}>
      <div className="child_class p-4" style={{ backgroundColor: "", border: "1px solid #252936", color: "#000", borderRadius: "6px" }}>
        <div className="signup_Text">
          <span style={{ color: "#62BD69" }}>Welcome Dealer</span>
        </div>

        <br />
        <p style={{ textAlign: "left", color: "#000" }}>Enter your details to login</p>

        {/* Email Input */}
        <div className="form__group field">
          <label className="form__label">Email</label>
          <input type="input" class="form__field" placeholder="Email" onChange={(e)=>setEmail(e.target.value)} name="name" id='name' required />
        </div>

        {/* Password Input */}
        <div className="form__group field" style={{ position: "relative" }}>
          <label className="form__label">Password</label>
          <input type={showPassword ? "text" : "password"} className="form__field" placeholder="Enter Password" onChange={(e) => setPassword(e.target.value)} required />
          <i
            className={`fa ${showPassword ? "fa-eye" : "fa-eye-slash"}`}
            onClick={() => setShowPassword(!showPassword)}
            style={{ position: "absolute", top: "50%", right: "10px", transform: "translateY(-50%)", color: "#a0d9ef", cursor: "pointer" }}
          ></i>
        </div>
        <br/>
        {/* Sign In Button */}
        <button type="button" className="btn" onClick={signin} disabled={loading} style={{ minWidth: "50%", border: "1px solid skyblue", backgroundColor: "", color: "#000" }}>
          {loading ? "Signing In..." : "Login"}
        </button>

        <br />
        <p>{msg}</p>
        <br />

        {/* Signup Link */}
      
      </div>
    </div>
  );
};

export default SigninForm;
